import { useMutation } from '@tanstack/react-query';
import { IClientInstallation, IProjectInstallation } from '@api/models';
import {
    removeFileProjectInstallation,
    updateFileProjectInstallation,
} from '@api/services/project-installation.service';

export const useFileUploadProjectInstallation = (
    clientInstallationId: string,
    initialData: IProjectInstallation,
    setData: (data: any) => void
) => {
    const addFileMutation = useMutation({
        mutationFn: (payload: any) => updateFileProjectInstallation(clientInstallationId, initialData._id, payload),
        onSuccess: (updatedInstallation) => {
            // setData((prev: IClientInstallation) => ({
            //     ...prev,
            //     files: [...(prev.files || []), ...newFiles],
            //   }));
            setData(updatedInstallation);
        },
    });

    const removeFileMutation = useMutation({
        mutationFn: (fileId: string) => removeFileProjectInstallation(clientInstallationId, initialData._id, fileId),
        onSuccess: (updatedInstallation) => {
            // setData((prev: IClientInstallation) => {
            //     const updatedFiles = [...(prev.files || [])];
            //     updatedFiles.splice(index, 1);
            //     return { ...prev, files: updatedFiles };
            //   });
            // setData(updatedInstallation);
        },
    });

    const handleAddFiles = (files: FileList | null) => {
        if (!files) return;

        const formData = new FormData();
        Array.from(files).forEach((file) => {
            formData.append('file', file);
        });

        addFileMutation.mutate(formData);
    };

    const handleRemoveFile = (fileId: string) => {
        removeFileMutation.mutate(fileId);
        setData((prev: IClientInstallation) => {
            const updatedFiles = prev.files?.filter((file: any) => file._id !== fileId) || [];
            return { ...prev, files: updatedFiles };
        });
    };

    return {
        handleAddFiles,
        handleRemoveFile,
        isUploading: addFileMutation.isLoading,
        isRemoving: removeFileMutation.isLoading,
    };
};
